import { defineQueries } from "@rocicorp/zero";
import {
  attachmentsQueries,
  channelPostingPermissionsQueries,
  invitesQueries,
  linkPreviewsQueries,
  reactionsQueries,
  userChannelStatsQueries,
} from "./auxiliary";
import { channelsQueries } from "./channels";
export { PRELOAD_MESSAGES_PER_CHANNEL } from "./channels";
import {
  channelNotificationOverridesQueries,
  deviceTokensQueries,
  dndSettingsQueries,
  notificationEventsQueries,
  notificationKeywordsQueries,
  notificationPreferencesQueries,
  pinsQueries,
  threadFollowersQueries,
  webPushSubscriptionsQueries,
} from "./notifications";
import { messagesQueries, type ThreadRepliesArgs } from "./messages";
import { channelMembersQueries, workspaceMembersQueries } from "./members";
import { usersQueries } from "./users";
import { userPresenceQueries } from "./user_presence";
import { workspacesQueries } from "./workspaces";
import { coworkersQueries } from "./coworkers";
import {
  clientSpacesQueries,
  clientSpaceMembersQueries,
  clientSpaceInviteLinksQueries,
} from "./client-spaces";
import {
  listsQueries,
  listItemsQueries,
  listItemCommentsQueries,
} from "./lists";
import { workspaceSkillsQueries } from "./workspace-skills";
import { workspaceJoinRequestsQueries } from "./workspace-join-requests";
import { sidebarQueries } from "./sidebar";
import { calendarEventsQueries } from "./calendar-events";
import { callEventsQueries } from "./call-events";
import { emailMessagesQueries } from "./email-messages";
import { messageMentionsQueries } from "./message-mentions";
import { communitySignalsQueries } from "./community-signals";
import { uiFlagsQueries } from "./ui-flags";

export const queries = defineQueries({
  users: usersQueries,
  user_presence: userPresenceQueries,
  workspaces: workspacesQueries,
  workspace_members: workspaceMembersQueries,
  channels: channelsQueries,
  channel_members: channelMembersQueries,
  messages: messagesQueries,
  reactions: reactionsQueries,
  community_signals: communitySignalsQueries,
  link_previews: linkPreviewsQueries,
  attachments: attachmentsQueries,
  notification_keywords: notificationKeywordsQueries,
  device_tokens: deviceTokensQueries,
  web_push_subscriptions: webPushSubscriptionsQueries,
  notification_events: notificationEventsQueries,
  notification_preferences: notificationPreferencesQueries,
  channel_notification_overrides: channelNotificationOverridesQueries,
  dnd_settings: dndSettingsQueries,
  user_ui_flags: uiFlagsQueries,
  thread_followers: threadFollowersQueries,
  pins: pinsQueries,
  channel_posting_permissions: channelPostingPermissionsQueries,
  invites: invitesQueries,
  user_channel_stats: userChannelStatsQueries,
  coworkers: coworkersQueries,
  client_spaces: clientSpacesQueries,
  client_space_members: clientSpaceMembersQueries,
  client_space_invite_links: clientSpaceInviteLinksQueries,
  lists: listsQueries,
  list_items: listItemsQueries,
  list_item_comments: listItemCommentsQueries,
  workspace_skills: workspaceSkillsQueries,
  workspace_join_requests: workspaceJoinRequestsQueries,
  sidebar: sidebarQueries,
  calendar_events: calendarEventsQueries,
  call_events: callEventsQueries,
  email_messages: emailMessagesQueries,
  message_mentions: messageMentionsQueries,
});

export const messageScreenQueries = {
  // Phase 3 — single composite for ThreadPanel: parent + replies +
  // thread_followers + per-message child relations in one subscription.
  threadComposite: ({ threadId }: ThreadRepliesArgs) =>
    queries.messages.byThreadComposite(threadId),
};

export { type ThreadRepliesArgs };
